import { SVGAttributes } from 'react'

export const NavigateRightThinIcon = (props: SVGAttributes<SVGElement>) => (
    <svg fill={props.color || 'white'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.717 13.368a2 2 0 0 0 0-2.736L8.507.809a1.154 1.154 0 1 0-1.684 1.579l8.377 8.928a1 1 0 0 1 0 1.368l-8.377 8.928a1.154 1.154 0 1 0 1.684 1.58z"
        />
    </svg>
)
